function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M38.412 19.977a12.191 12.191 0 0 1-20.305 8.929.576.576 0 0 1-.022-.842l.831-.821a.6.6 0 0 1 .812-.019 9.842 9.842 0 0 0 6.527 2.453 9.678 9.678 0 1 0 0-19.355 9.836 9.836 0 0 0-6.955 2.857l2.4 2.343a.58.58 0 0 1-.413.994H15a.585.585 0 0 1-.588-.581V9.812a.589.589 0 0 1 1-.413l2.211 2.152a12.19 12.19 0 0 1 20.788 8.427zm-8.189 4.363.692-.939a.576.576 0 0 0-.13-.811l-3.354-2.407v-6.957a.585.585 0 0 0-.588-.581h-1.176a.585.585 0 0 0-.588.581v8.14l4.323 3.1a.593.593 0 0 0 .821-.125z",
    transform: "translate(-14.412 -8)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryIcon);
export default __webpack_public_path__ + "static/media/history-icon.4c60dfe3.svg";
export { ForwardRef as ReactComponent };